// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"312":"e81304dab0bc8ab7","888":"1aba2955ac4c0641"}[chunkId] + ".css";
};